import "./article_bti_frontpage.css";

export default (article) => {

    let pageColor = article.metaDynamic["Farge"].value;
    $("#maincontent").addClass(pageColor);
    $("#warnings_container").addClass(pageColor);
    $(".footer__pre").addClass(pageColor);

    return `
    <div class="row justify-content-md-center ${article.pageTypeId}">
        <div class="col-md-7">
            ${article.mainImage} 
        </div>
        
        <div class="col-md-7">
            <div class="article article__main article__template__${article.pageTypeId} p-0">
                    <h1 class="article__header">${article.title}</h1>
                    ` +
        (article.parsedIntro.length > 2 ?
            `<div class="article__intro">${article.parsedIntro}</div>` :
            ``) +
        `
                <div class="article__content">
                    ${article.content}
                </div>
            </div>
        </div>
        ${
          article.hasRightColumn
            ? `<div class="col-sm-4 offset-sm-1">${article.rightColumn}</div>`
            : ""
        }
    </div>
    `;
}
